<template>
  <form @submit.prevent>
    <div>
      <h2>
        <span v-if="isEditMode">"{{ editedEntity.name | translate }}" {{ $t("common.update") }}</span>
        <span v-else>{{ $t("electronic-storage-category.new") }}</span>
      </h2>

      <!-- form input start-->
      <sweet-input
        v-model="form.name"
        :isValid="!$v.form.name.$error"
        @input="$v.form.name.$touch()"
        layout="vertical"
        :placeholder="$t('common.name')"
        :label="$t('electronic-storage-category.text')"
      />
      <br />

      <h6 class="mt-4">{{ $t("sector.name") }}</h6>
      <filter-select
        id="sectorFilter"
        ref="sectorFilter"
        :placeholder="$t('sector.text')"
        :multiple="false"
        @filter="onSectorSearch"
        :selected="form.sector"
        @changed="onSectorSelect"
      />
      <br />
      <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
        {{ $t("common.save") }}
      </sweet-button>
    </div>
  </form>

  <!-- form input end -->
</template>

<script>
import { maxLength, minLength, required } from "vuelidate/lib/validators";

const state = "managementElectronicStorageCategory";

export default {
  props: {
    closeOnSave: { type: Boolean, default: true },
  },
  data() {
    return {
      form: {
        name: undefined,
        sector: undefined,
      },
      formError: undefined,
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(350),
      },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form = { ...this.prepareFormForEdit(v) };
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters[`${state}/isUpdating`];
    },
    editedEntity() {
      return this.$store.getters[`${state}/editedEntity`];
    },
    isEditMode() {
      return this.$store.getters[`${state}/isEditMode`];
    },
  },
  mounted() {},
  methods: {
    async save() {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }
      try {
        const { data } = await this.$store.dispatch(`${state}/save`, this.form);
        this.form = {};
        this.$toast.success(this.$t("common.success"));
        if (this.closeOnSave) {
          this.$root.$emit("bv::toggle::collapse", "sidebar-new-electronic-storage-category");
        }
        setTimeout(() => this.$emit("onSave", data), 500);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async onSectorSearch(value, callback) {
      const response = await this.$store.dispatch(`managementSector/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onSectorSelect(item) {
      this.form = { ...this.form, sector: item };
    },
  },
};
</script>
